/*
 * @Author: your name
 * @Date: 2020-11-03 16:10:38
 * @LastEditTime: 2021-04-06 14:11:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\utils\http.js
 */


import request from './request'

const http = {
    /**
     * @param methods: 请求方式
     * @param url 请求地址 
     * @param params 请求参数
     */
     axios(methods,url,params){
        const config = {
            method:methods,
            url:url,
        }
       if(params){  
            if(methods == 'post'){
                config.data = params
            }else{
                config.params = params
            }
       }
      
        return request(config)
    },
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/utils/http.js